import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import downarrow from "../../../images/downarrow.svg";
import whitedown from "../../../images/whitedown.svg";
import whitecalender from "../../../images/whitecalender.svg";
import whiteselectdown from "../../../images/whiteselectdown.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { leaguesData } from "../data";
import { useGetGamesQuery } from "../../../store/apis";
import { transformApiData } from "../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedLeague,
  setLeagues,
  setSelectedLeague,
} from "../../../store/league-slice";
import LeagueList from "./LeagueList";
const Match = () => {
  const [activeOdd, setActiveOdd] = useState(null);
  const [selectedOdd, setSelectedOdd] = useState(
    leaguesData[0]?.titleWrps[0]?.matches[0]?.odds[0][0] || null
  );
  const [expandedLeagues, setExpandedLeagues] = useState({});
  const [mobileDisplayOption, setMobileDisplayOption] = useState("1x2");
  const [selectedDay, setSelectedDay] = useState("TODAY");
  const [selectedHour, setSelectedHour] = useState(null);
  const [sortOption, setSortOption] = useState("league");
  const { data, isLoading } = useGetGamesQuery();
  const [transformedData, setTransformedData] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const selectedLeague = useSelector(selectSelectedLeague);
  const [selectedSport, setSelectedSport] = useState(null);
  const dispatch = useDispatch();

  const items = [
    { text: "Hrs", icon: downarrow, darkIcon: whitedown },
    { text: "TODAY" },
    { text: "THU" },
    { text: "FRI" },
    { text: "SAT" },
    { text: "SUN" },
    {
      text: "",
      icons: [whitecalender, whitedown],
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 639);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const extractLeaguesFromData = (data) => {
    if (!data) return [];

    // const transformedData = transformApiData(data);

    // Create league objects from transformed data
    return data.map((league) => ({
      name: league.leagueTitle,
      country: league.leagueTitle.split(" - ")[0] || "",
      count: league.titleWrps.reduce(
        (total, wrap) => total + wrap.matches.length,
        0
      ),
    }));
  };
  useEffect(() => {
    if (data) {
      const transformedData = transformApiData(data);
      setTransformedData(transformedData);
      const extractedLeagues = extractLeaguesFromData(transformedData);
      dispatch(setLeagues(extractedLeagues));
      // setLeagues(extractedLeagues);

      // Select first league by default
      if (extractedLeagues.length > 0) {
        dispatch(setSelectedLeague(extractedLeagues[0]));
      }
    }
  }, [data]);
  // Function to filter and sort data
  const getFilteredAndSortedData = () => {
    if (!selectedLeagueData) return [];

    let filteredData = [...selectedLeagueData];

    // Filter by selected sport
    if (selectedSport) {
      filteredData = filteredData.filter((league) =>
        league.leagueTitle.includes(selectedSport)
      );
    }

    // Filter by selected hour
    if (selectedHour) {
      filteredData = filteredData.filter((league) => {
        return league.titleWrps.some((wrp) =>
          wrp.matches.some((match) =>
            match.details.some((detail) =>
              detail.text.includes(selectedHour.split(" ")[0])
            )
          )
        );
      });
    }

    // Sort the data
    if (sortOption === "time") {
      filteredData.sort((a, b) => {
        const timeA =
          a.titleWrps[0]?.matches[0]?.details.find((d) => d.text.includes(":"))
            ?.text || "";
        const timeB =
          b.titleWrps[0]?.matches[0]?.details.find((d) => d.text.includes(":"))
            ?.text || "";
        return timeA.localeCompare(timeB);
      });
    } else {
      filteredData.sort((a, b) => a.leagueTitle.localeCompare(b.leagueTitle));
    }

    return filteredData;
  };
  // Helper function to determine which odds groups to display
  const getOddsGroup = (match, groupIndex) => {
    if (mobileDisplayOption === "1x2" && groupIndex === 0) return true;
    if (mobileDisplayOption === "double-chance" && groupIndex === 1)
      return true;
    if (mobileDisplayOption === "gg-ng" && groupIndex === 2) return true;
    if (mobileDisplayOption === "to-qualify" && groupIndex === 3) return true;
    return !window.matchMedia("(max-width: 640px)").matches; // Show all on desktop
  };
  const selectedLeagueData = useMemo(() => {
    if (!selectedLeague || !transformedData) return [];
    return transformedData.filter(
      (league) => league.leagueTitle === selectedLeague.name
    );
  }, [selectedLeague, transformedData]);
  const filteredAndSortedData = getFilteredAndSortedData();

  // Reset all filters
  const clearAllFilters = () => {
    setSelectedDay("TODAY");
    setSelectedHour(null);
    setSelectedSport(null);
  };
  return (
    <>
      <div className="max-sm:mt-0 mt-3 s18:mt-[17px] sm:rounded-lg bg-teal shadow-dashboardshadow">
        {/* sports / Hrs icon TODAY THU FRI SAT SUN */}
        <StickyHeader />
        {/* leage / 1*2 / double chance header */}
        <div className="scrollable">
          <div className="max-md:min-w-0 max-lg:min-w-[732px] flex items-center justify-between max-sm:p-[8px_15px] py-3 px-5 s18:p-[15px_23px]">
            <select className="rounded-md bg-forestGreen py-2 px-[11px] s18:p-[9px_11px] w-[247px] border-none outline-none text-white text-sm font-normal leading-12 appearance-none max-md:mx-2">
              <option value="" selected>
                Sort by league
              </option>
              <option value="option1">Sort by time</option>
            </select>
            <span className="text-white text-sm font-normal leading-tight max-md:hidden">
              1X2
            </span>
            <span className="text-white text-sm font-normal leading-tight max-md:hidden">
              Double chance
            </span>
            <select className="rounded-md bg-forestGreen py-2 px-[11px] s18:p-[9px_11px] w-[213px] border-none outline-none text-white text-sm font-normal leading-12 appearance-none max-md:mx-2">
              <option value="" selected>
                GG/NG
              </option>
              <option value="option1">To qualify</option>
            </select>
          </div>
        </div>
        {/* leage data */}
        {/* League List Component */}
        {filteredAndSortedData.length > 0 ? (
          <LeagueList
            filteredAndSortedData={filteredAndSortedData}
            expandedLeagues={expandedLeagues}
            setExpandedLeagues={setExpandedLeagues}
            getOddsGroup={getOddsGroup}
            selectedOdd={selectedOdd}
            setSelectedOdd={setSelectedOdd}
          />
        ) : (
          <div className="p-6 text-center text-mutedblue dark:text-white">
            No matches found for the selected filters.
          </div>
        )}
      </div>
    </>
  );
};

const StickyHeader = () => {
  const items = [
    { text: "TODAY" },
    { text: "THU" },
    { text: "FRI" },
    { text: "SAT" },
    { text: "SUN" },
  ];
  const [startDate, setStartDate] = useState(null);
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="sticky max-[420px]:top-20 top-20 sm:top-20 md:top-28 lg:top-28 xl:top-28 s15:top-28 s16:top-[118px] s18:top-28 rounded-md bg-teal shadow-dashboardshadow">
        <div className="max-sm:flex-col max-sm:items-start max-sm:p-[8px_15px_0px] flex p-[0px_20px] items-center justify-between border-b-[1px] border-solid border-lightborderyellow">
          <span className="text-white text-base s18:text-xl font-bold leading-none">
            Sports
          </span>
          <ul className="max-sm:w-full flex gap-3 md:gap-5 items-center justify-between">
            <li className="sport-first-item max-sm:whitespace-nowrap max-sm:p-[5px_0px] py-3 s18:p-[27px_0px_27px] relative flex items-center cursor-pointer text-white text-xs md:text-sm s18:text-base font-medium !leading-tight s18:leading-[143%] hover:text-yellow transition-all duration-300 after:absolute after:content-[''] after:bg-darkblue after:w-[0px] after:left-[50%] after:translate-x-[-50%] after:h-[2px] after:mx-auto after:bottom-0 after:transition-all after:duration-300 hover:after:w-full hover:after:bg-yellow">
              <select name="hours" id="hours" className="bg-transparent">
                <option value="hrs">Hrs</option>
                <option value="12hrs">12hrs</option>
                <option value="10hrs">10hrs</option>
                <option value="8hrs">8hrs</option>
              </select>
            </li>
            {items.map((item, index) => (
              <li
                key={index}
                className="max-sm:whitespace-nowrap max-sm:p-[5px_0px] py-3 s18:p-[27px_0px_27px] text-xs md:text-sm relative flex items-center cursor-pointer text-white s18:text-base font-medium  !leading-tight s18:leading-[143%] hover:text-yellow transition-all duration-300 after:absolute after:content-[''] after:bg-darkblue after:w-[0px] after:left-[50%] after:translate-x-[-50%] after:h-[2px] after:mx-auto after:bottom-0 after:transition-all after:duration-300 hover:after:w-full hover:after:bg-yellow"
              >
                {item.text && <span>{item.text}</span>}
                {item.icon && (
                  <img
                    src={item.darkIcon}
                    alt="icon"
                    className="min-w-[10px] ml-[4px]"
                  />
                )}
                {item.icons &&
                  item.icons.map((icon, i) => (
                    <img
                      key={i}
                      src={icon}
                      alt="icon"
                      className={i > 0 ? "min-w-[10px] ml-[4px]" : ""}
                    />
                  ))}
              </li>
            ))}
            <li className="flex items-center">
              <div className="relative">
                <div
                  className="relative flex items-center sport-section"
                  onClick={() => setOpen(!open)}
                >
                  <img
                    src={whitecalender}
                    alt="icon"
                    className="min-w-[10px] ml-[4px]"
                  />
                  <img
                    src={whitedown}
                    alt="icon"
                    className="min-w-[10px] ml-[4px]"
                  />
                </div>
                {open && (
                  <div className="absolute top-6 sm:top-8 s18:top-12 right-0 z-50">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        setStartDate(date);
                        setOpen(false);
                      }}
                      inline
                      calendarClassName="custom-calendar !bg-white"
                    />
                  </div>
                )}
              </div>
            </li>
          </ul>
        </div>
        <div className="max-sm:p-[8px_0px_8px_15px] p-[12px_0px_12px_20px] s18:p-[22px_0px_22px_20px]">
          <ul className="flex max-sm:gap-[15px] sm:gap-[23px] overflow-auto scrollable min-h-5">
            {sportsData.map((sport, index) => (
              <li
                key={index}
                className="cursor-pointer flex items-center whitespace-nowrap text-white hover:text-yellow text-sm s18:text-base font-normal leading-[143%] transition-all duration-300 "
              >
                {sport.name}
                <span className="pt-[2px] min-w-[33px] min-h-5 ml-[5px] rounded-[23px] bg-yellow flex justify-center items-center text-white text-sm font-medium leading-tight last:mr-3b">
                  {sport.count}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Match;

const sportsData = [
  { name: "Soccer", count: 135 },
  { name: "eSports", count: 27 },
  { name: "Basketball", count: 45 },
  { name: "Ice Hockey", count: 41 },
  { name: "Volleyball", count: 35 },
  { name: "Handball", count: 31 },
  { name: "Futsal", count: 13 },
  { name: "Darts", count: 8 },
  { name: "Waterpolo", count: 8 },
];
